import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserRecordIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 31,
		height: 31,
		rx: 15.5,
		fill: "#1377E7",
		stroke: "#1377E7"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.1079 20.8432H13.6251L20.0733 14.3979L18.5814 12.856L12.1079 19.3266V20.8432ZM20.5285 13.9429L21.5147 12.9571C21.631 12.8409 21.6968 12.7094 21.7069 12.5628C21.717 12.4162 21.6513 12.2798 21.5147 12.1433L20.7814 11.4356C20.6448 11.2991 20.5133 11.2384 20.3768 11.2435C20.2402 11.2485 20.1138 11.3142 19.9975 11.4356L19.0366 12.396L20.5285 13.9378V13.9429Z",
		fill: "#FCFCFC"
	})]
});
export default SvgUserRecordIcon;
